module.exports = __webpack_public_path__ + "assets/image-mini-icon.adab99fd.svg";